import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { wbStripHtmlEvents } from "../../utils/common";
import MainDetailsMeetingWrapper from "./mainDetailsMeetingWrapper";
import { WoboFileUploadService } from '../../../src/services/fileupload.service'

class NewMeetingApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTopicDescEdit: false,
      takeTopic: [],
      mentionsUserData: null,
      enableDesc: false,
      showAddAttendeePopup: false,
      showAttendeeOpts: false,
      attendeeOptId: null,
      tempVar: false,
      takeTopicId: "",
      emptyGlobalTag: 0,
      disabledDoneBtn: 0,
      resetTopicTag: 0,
      topicEmptyData: [],
      topicCount: 0
    };
    window.MeetingApp = this;
    this.refreshLegacyData = props.refreshLegacyData;
    this.defaultDescState = this.defaultDescState.bind(this);
    this.wsNameUpdate = this.wsNameUpdate.bind(this);
    this.registerMeetingSubscription = this.registerMeetingSubscription.bind(
      this
    );
    this.removeTypingAlert = this.removeTypingAlert.bind(this);
    this.joinHandler = this.joinHandler.bind(this);
    this.leftHandler = this.leftHandler.bind(this);
    this.typingHandler = this.typingHandler.bind(this);
    this.syncMeetingData = this.syncMeetingData.bind(this);
    this.editTopicArea = this.editTopicArea.bind(this);
    this.shareMeetingTopic = this.shareMeetingTopic.bind(this);
    this.saveTags = this.saveTags.bind(this);
    this.saveMeetingInvitees = this.saveMeetingInvitees.bind(this);
    this.updateMeetingName = this.updateMeetingName.bind(this);
    this.removeMeetingInvitee = this.removeMeetingInvitee.bind(this);
    this.updateMeetingInviteeAccess = this.updateMeetingInviteeAccess.bind(
      this
    );
    this.saveMeetingNullTopicNote = this.saveMeetingNullTopicNote.bind(this);
    this.saveMeetingTopic = this.saveMeetingTopic.bind(this);
    this.clearQuickAddParams = this.clearQuickAddParams.bind(this);
    this.updateTopicTake = this.updateTopicTake.bind(this);
    this.currentDateTime = this.currentDateTime.bind(this);
    this.saveMeetingTakeAway = this.saveMeetingTakeAway.bind(this);
    this.deleteTopicTakeNonTake = this.deleteTopicTakeNonTake.bind(this);
    this.enablegroupText = this.enablegroupText.bind(this);
    this.addDesc = this.addDesc.bind(this);
    this.showAddAttendeePopupClick = this.showAddAttendeePopupClick.bind(this);
    this.showAttendeeOptsDiv = this.showAttendeeOptsDiv.bind(this);
    this.hideAttendeeOptsDiv = this.hideAttendeeOptsDiv.bind(this);
    this.keypress = this.keypress.bind(this);
    this.sortItemNotes = this.sortItemNotes.bind(this);
    this.sortTakeNotes = this.sortTakeNotes.bind(this);
    this.addTopicAttach = this.addTopicAttach.bind(this);
    this.addNoteAttach = this.addNoteAttach.bind(this);
    this.deleteTopicAttach = this.deleteTopicAttach.bind(this);
    this.deleteNoteAttach = this.deleteNoteAttach.bind(this);
    this.clearGlobalValue = this.clearGlobalValue.bind(this);
    this.clearGlobalValueBta = this.clearGlobalValueBta.bind(this);
    this.emptyDOM = this.emptyDOM.bind(this);
    this.saveInitMeetingTopicTakeaway = this.saveInitMeetingTopicTakeaway.bind(this);
    this.updateTopicAttach = this.updateTopicAttach.bind(this);
    this.updateNoteAttach = this.updateNoteAttach.bind(this);
  }

  componentDidUpdate({ meetingData }) {
    const { workstream, meeting: { ws_id } } = meetingData
    if (ws_id || !workstream) return
    const { id: wsId, name: wsName } = workstream
    this.wsNameUpdate(null, { wsId, wsName })
  }

  componentDidMount() {
    const _this = this;
    $(document).on("ws_name_update_comp", {}, this.wsNameUpdate);
    this.defaultDescState();
    // window.addEventListener("click", this.handleBodyClick, true);
    const { meeting, currentUser, selectedUser, meeting_topics } = this.props.meetingData;

    this.setState({
      topicCount: meeting_topics.length,
    });

    if (meeting.status == "1") {
      this.registerMeetingSubscription(meeting.id, currentUser.id);
    }

    let { name } = meeting;
    if (meeting.type == 1) {
      name = `1on1 with ${selectedUser.fullName}`;
    }
    updateRecentItemsTopMenu(meeting.id, "recent_meeting", name);
    highlightLeftMenuNav("meeting", meeting.id, "meeting", meeting);

    // TODO: refactor this jquery stuff out asap
    $(document).off("click", "#reopen-meeting-confirm #reopen_meeting_btn");
    $(document).on(
      "click",
      "#reopen-meeting-confirm #reopen_meeting_btn",
      () => {
        _this.emptyDOM();
        $(document).trigger("meeting_comp_safe_render");
      }
    );
    $(document).on("unmount_meeting_app_comp", {}, this.emptyDOM);
  }

  componentWillUnmount() {
    // window.removeEventListener("click", this.handleBodyClick);
    // window.addEventListener("click", this.workstreamListPopupClose, true);
    window.NewMeetingApp = null;
  }

  emptyDOM() {
    if (document.getElementById("msDetailsPage")) {
      ReactDOM.unmountComponentAtNode(document.getElementById("msDetailsPage"));
    }
  }

  defaultDescState() {
    const defult = !!$.trim(this.props.meetingData.meeting.objective);
    this.setState({
      enableDesc: defult
    });
  }

  wsNameUpdate(e, args) {
    const { actions } = this.props;
    if (typeof args.wsName !== "undefined") {
      actions.MeetingWorkstreamNameUpdate(args.wsId, args.wsName);
    }
  }
  // Note: Pending verify if this is still a thing, or if it can be removed
  registerMeetingSubscription(meetingID, userId) {
    // Daryoush requested to disable websockets until we have a better grasp on locking
    // https://cameronbothner.com/pessimistic-locking/
    return
    const _this = this;
    const allEvents = {
      typing: 1,
      joined: 2,
      left: 3,
      createTopic: 4,
      createTakeAways: 5
    };

    // unregister meet event
    unregister("meet");

    // nodeUrl is defined the js variable in controller.
    // c_id is user session ie) also defined in controller.
    const host = `${wbConfig.nodeUrl}/meets`;
    const csrfToken = $.ajaxSetup().data.YII_CSRF_TOKEN;
    const socketConnection = {
      reconnect: false,
      "try multiple transports": false,
      query: `csrf=${csrfToken}&cId=${wbConfig.client_id}`,
      extra: "header_1_test"
    };

    // connect socket.io
    const meetingSocket = io.connect(host, socketConnection);

    // start heart beat once socket is connected.
    setTimeout(() => {
      meetingSocket.emit("ping", { beat: 1 });
    }, 25000);

    // register meet event with meeting id and user id
    register("meet", { mS: meetingSocket, mId: meetingID, uId: userId });
    const gUserId = getUserId();
    if (typeof userId === "undefined") {
      userId = gUserId;
    }

    meetingSocket.on("connect", () => {
      // update the socket again once gets connected
      register("meet", { mS: meetingSocket, mId: meetingID, uId: userId });
      // send join message
      meetingSocket.emit("join", { id: meetingID, uid: userId });
    });

    /**
     * When connecting
     */
    meetingSocket.on("connecting", () => {
      // console.log('connecting');
    });

    /** *
     * On disconnect, handle it gracefully
     */
    meetingSocket.on("disconnect", () => {
      // send join message
      meetingSocket.emit("leave", { id: meetingID });
      // console.log('disconnect');
      // clear the name space
      meetingSocket.io.nsps = {};
    });

    meetingSocket.on("pong", data => {
      // console.log("pong..");
    });
    meetingSocket.on("connect_failed", () => {
      // console.log('connect_failed');
    });
    meetingSocket.on("error", err => {
      // console.log('error: ' + err);
    });
    meetingSocket.on("reconnect_failed", () => {
      // console.log('reconnect_failed');
    });
    meetingSocket.on("reconnect", () => {
      // console.log('reconnected ');
    });
    meetingSocket.on("reconnecting", () => {
      // console.log('reconnecting');
    });

    meetingSocket.on("meeting", data => {
      if (typeof data.type !== "undefined") {
        const eventType = data.type;
        switch (eventType) {
          case allEvents.typing:
            _this.typingHandler(data);
            break;
          case allEvents.left:
            _this.leftHandler(data.id);
            break;
          case allEvents.joined:
            _this.joinHandler(data.id);
            // once joining is done, notify the user that you are also in the meeting with
            // me_too signal
            // console.log("Emit me_too signal as you are also in");
            meetingSocket.emit("me_too", { id: data.mid, uid: gUserId });
            break;
          case allEvents.createTopic:
            if (typeof data.mData !== "undefined") {
              _this.removeTypingAlert();
              _this.syncMeetingData(data.mData);
            }
            break;
          case allEvents.createTakeAways:
            // createTakeAwaysHandler();
            break;
        }
      }
    });
  }

  /**
   * removing typing handler
   */
  removeTypingAlert() {
    $("#topic")
      .delay(100)
      .fadeOut();
  }

  /**
   * joining the meeting.
   * @param {*} userId
   */
  joinHandler(userId) {
    const photoSelector = $(
      `div.teamMeetingInviteeImgDiv[data-member-id='${userId}']`
    );
    const foundPhotoSelector = photoSelector.find(".roundFramePhoto");
    foundPhotoSelector.addClass("member-live");
    foundPhotoSelector.css("position", "relative");
    // before adding the div, remove it if available
    photoSelector.find(".typingImage").remove();
    photoSelector.append("<div class='typingImage'></div>");
    // by default for one on one, show the id
    $("#typing-alert").show();
    foundPhotoSelector.animate(
      {
        top: -25
      },
      2000,
      "easeOutBounce"
    );

    foundPhotoSelector.css("position", "static");
  }

  leftHandler(userId) {
    const photoSelector = $(
      `div.teamMeetingInviteeImgDiv[data-member-id='${userId}']`
    );
    const photoFinderSelector = photoSelector.find(".roundFramePhoto");
    photoSelector.find(".typingImage").remove();
    photoFinderSelector.removeClass("member-live");
    // for one on one, remove the image
    $("#typing-alert").hide();
  }

  typingHandler(data) {
    const topicSelector = $("#topic");
    if (data.show) {
      topicSelector.delay(100).fadeIn();
      let name = data.uData.fullName;
      if (
        typeof name !== "undefined" &&
        name !== null &&
        name.trim().length > 0
      ) {
        const nameSplit = name.split(" ");
        if (nameSplit.length > 0) {
          name = nameSplit[0];
        }
      }
      $("#topic-text")
        .html("")
        .text(`${name} is typing`);
    } else {
      topicSelector.delay(100).fadeOut();
    }
  }

  syncMeetingData(data) {
    const { actions } = this.props;
    if (typeof data.type !== "undefined" && data.data !== "undefined") {
      actions.MeetingSyncData(data);
    }
  }

  editTopicArea() {
    const _this = this;
    setTimeout(() => {
      _this.setState({
        showTopicDescEdit: true
      });
    }, 10);
  }

  shareMeetingTopic(topic) {
    const url = `${wbConfig.baseUrl}/restapi/meetings/${topic.meeting_id}/topics/${topic.id}`
    if (topic.access == 0) {
      topic.access = 1;
    } else if (topic.access == 1) {
      topic.access = 0;
    } else {
      window.history.pushState({ showError: `Unknown topic access ${topic.access}` }, '', window.location.href);
      return;
    }

    window.showAppLoader('updateAccess');
    $.ajax({
      method: 'PATCH', url, data: topic, success: (data, status) => {
        if (data.error) {
          window.history.pushState({ showError: data.error }, '', window.location.href);
        } else if (status == "success") {
          this.refreshLegacyData(data.data);

          create_topic("meet", {
            action: "tag_update",
            type: 'topic',
            data: data.data,
            topicId: topic.id
          });
        }
      }
    })
      .always(() => {
        window.hideAppLoader('updateAccess');
      });
  }

  saveTags(meetingId, tagId, stateId, TypeStr, act, topicId = null) {
    const { meetingData } = this.props;
    if (act == "edit") {
      let wsId = null;
      const tagVal = -11;
      if (tagId == 1) {
        wsId =
          meetingData.meeting.ws_id != null
            ? meetingData.meeting.ws_id
            : tagVal;
      }
      const fieldData = `&YII_CSRF_TOKEN=${$.ajaxSetup().data.YII_CSRF_TOKEN}&meeting_id=${meetingId}&tag=${tagId}&id=${stateId}&type=${TypeStr}&tagId=${wsId}`;
      let url = "";
      if (TypeStr == "topic") {
        url = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/${topicId || stateId}`
      } else {
        url = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/${topicId}/takeaways/${stateId}`
      }
      window.showAppLoader('saveTags');
      $.ajax({
        method: 'PATCH', url, data: fieldData, success: (data, status) => {
          if (data.error) {
            window.history.pushState({ showError: data.error }, '', window.location.href);
          } else if (status == "success") {
            this.refreshLegacyData(data.data);

            create_topic("meet", {
              action: "tag_update",
              type: TypeStr,
              data: data.data,
              topicId
            });
          }
        }
      })
        .always(() => {
          window.hideAppLoader('saveTags');
        });
    }
  }
  resetMeetingTakesForSmartWobo = resetValue => {
    this.props.actions.resetMeetingTakesForSmartWobo(resetValue);
  };

  getPredictionResultForTakeaway = response => {
    if (response.data && response.data.results) {
      const resultData = response.data.results.filter(result => {
        if (result.WBAIpredictionType === "ActionItem") {
          return true;
        }
      });
      if (resultData && Array.isArray(resultData) && resultData.length && resultData[0].score) {
        return resultData[0].score;
      }
    } else {
      return false;
    }
  };

  saveTakeawayAsAi = (topicId, aiOwnerId, meetingId, tagId, stateId, act) => {
    const { actions, meetingData } = this.props;
    const TypeStr = "take";

    if (act == "edit") {
      let wsId = null;
      const tagVal = -11;
      if (tagId == 1) {
        wsId =
          meetingData.meeting.ws_id != null
            ? meetingData.meeting.ws_id
            : tagVal;
      }
      let fieldDataStructure = {
        YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
        meeting_id: meetingId,
        tag: tagId,
        id: stateId,
        type: TypeStr,
        tagId: wsId,
        userId: aiOwnerId
      };
      const url = wbConfig.baseUrl + '/meeting/saveMeetingTake';

      $.post(url, fieldDataStructure, (data, status) => {
        if (status == "success") {
          if (tagId == "1") {
            actions.MeetingTopicTakeUpdate(stateId, topicId, {
              ai_id: data.data.ai_id,
              aiOwnerName: data.data.aiOwnerName,
              wobo_data: data.data.wobo_data
            });
          }

          this.refreshLegacyData();

          create_topic("meet", {
            action: "tag_update",
            type: TypeStr,
            data: data.data,
            topicId
          });
        }
      });

      actions.MeetingAddTakeTag(stateId, tagId, topicId, {
        id: stateId,
        tagId,
        topicId
      });
    }
  };

  saveMeetingInvitees(meetingId, responseVal) {
    const { actions } = this.props;
    actions.MeetingUpdateInvitees(meetingId, { inviteeVal: responseVal });

    this.setState({
      showAddAttendeePopup: false
    });
  }

  updateMeetingName(meetingName) {
    const { actions } = this.props;
    actions.MeetingNameUpdate({ meetingName });
  }

  removeMeetingInvitee(userId) {
    const { actions } = this.props;
    actions.MeetingRemoveInvitee({ userId });
  }

  updateMeetingInviteeAccess(userId, isAdminVal) {
    const { actions } = this.props;
    actions.MeetingUpdateInviteeAccess({ userId, isAdminVal });
  }

  findTakeInTopics(topics, topicId, pos, description) {
    const trimmedDescription = description.trim();
    const positionAsText = pos + '';
    let topic;

    if (topicId) {
      topic = topics && topics.find(t => t.id === topicId);
      return topic ? this.findTake(topic.topic_take, positionAsText, trimmedDescription) : null;
    } else {
      for (const topic of topics) {
        let take = this.findTake(topic.topic_take, positionAsText, trimmedDescription);
        if (take) {
          return take;
        }
      }
    }

    return null;
  }

  findTake(takes, pos, description) {
    return takes ? takes.find(tk => tk.pos === pos && tk.description.trim() === description) : null;
  }

  saveMeetingNullTopicNote(
    desc,
    meetingId,
    tag,
    pos,
    fname,
    lname,
    topicRelId,
    quickAddAI = false,
    quickAddAIParams = {},
    callback = null
  ) {
    const textEmpty = "";
    const textTag = 0;
    const wobo_type = "topic";
    const { actions } = this.props;
    const curDateTime = this.currentDateTime();
    const _this = this;
    const randNum = Math.floor(Math.random() * 10000000) + 1;
    const tempAiId = randNum;
    const access = 1;
    const canEdit = true;
    const canDelete = true;
    const added_by = this.props.meetingData.currentUser.id;

    actions.MeetingAddTopicItems({
      id: tempAiId,
      description: textEmpty,
      pos,
      tag: textTag,
      meeting_id: meetingId,
      firstname: fname,
      lastname: lname,
      create_period: curDateTime,
      access,
      canEdit,
      canDelete,
      added_by,
      wobo_type,
      aiOwnerName: fname
    });

    let fieldDatas = {
      YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
      meeting_id: meetingId,
      description: desc,
      tag,
      pos,
      topicId: topicRelId
    };
    if (quickAddAI == true) {
      fieldDatas.tag = 1; // required to distinguish an AI, removes a smartbullet
      fieldDatas = Object.assign({}, fieldDatas, quickAddAIParams);
    }
    const fieldId = `meeting_take_${meetingId}${topicRelId != "" ? `_${topicRelId}` : ""
      }`;
    const fieldObj = $(`#${fieldId}`);
    const addAiUrlNote = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/0/takeaways`
    window.showAppLoader('saveMeetingNullTopicNote');
    $.post(addAiUrlNote, fieldDatas, (response, status) => {
      $(fieldObj).prop("disabled", true);
      if (response.error) {
        $(fieldObj).val(desc);
        actions.MeetingDelteTopic(tempAiId);
        window.history.pushState({ createAIError: response.error }, '', window.location.href);
      } else if (status == "success") {
        _this.clearQuickAddParams(fieldObj);
        this.setState({
          topicCount: response.data.length
        }, () => {
          window.history.pushState({ topicCountChange: 1, currentTopicCount: this.state.topicCount - 1 }, '', window.location.href);
        });

        this.refreshLegacyData(response.data);

        const take = this.findTakeInTopics(response.data, topicRelId, pos, desc);
        if (take) {
          create_topic("meet", {
            action: "add",
            data: take,
            type: "topic"
          });
        }

        if (typeof callback === "function") {
          const takeId = take ? take.id : '';
          callback.call(takeId, desc);
        }
      }
    }).catch((e) => {
      if (e.responseJSON.data) {
        toastr.error(e.responseJSON.data)
      }
    })
      .always(() => {
        window.hideAppLoader('saveMeetingNullTopicNote');
      });
  }

  saveMeetingTopic(
    desc,
    meetingId,
    tag,
    pos,
    fname,
    lname,
    wobo_type,
    quickAddAI = false,
    quickAddAIParams = {},
    topicToTake = false
  ) {
    const { actions } = this.props;
    const curDateTime = this.currentDateTime();
    const _this = this;
    const addAiUrl = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics`;
    const randNum = Math.floor(Math.random() * 10000000) + 1;
    const tempAiId = randNum;
    const access = 1;
    const canEdit = true;
    const canDelete = true;
    const added_by = this.props.meetingData.currentUser.id;
    const tagId = this.props.meetingData.meeting.ws_id;
    let fieldData = {
      YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
      description: desc,
      meeting_id: meetingId,
      tag,
      pos
    };
    if (quickAddAI == true) {
      tag = 1; // required to distinguish an AI, removes a smartbullet
      fieldData.tag = tag;
      fieldData = Object.assign({}, fieldData, quickAddAIParams);
      if (!fieldData.tagId) {
        fieldData.tagId = tagId;
      }
    }

    if (topicToTake != true) {
      actions.MeetingAddTopicItems({
        id: tempAiId,
        description: wbStripHtmlEvents(desc),
        pos,
        tag,
        meeting_id: meetingId,
        firstname: fname,
        lastname: lname,
        create_period: curDateTime,
        access,
        canEdit,
        canDelete,
        added_by,
        wobo_type,
        aiOwnerName: fname
      });
    }
    const fieldObj = $(`#meeting_topic_${meetingId}`);
    if (topicToTake == true) {
      $(fieldObj).val(desc).html(desc)
    }
    window.showAppLoader('saveMeetingTopic');
    const posting = $.post(addAiUrl, fieldData, (response, status) => {
      $(fieldObj).prop("disabled", true);
      if (response.error) {
        $(fieldObj).val(desc);
        actions.MeetingDelteTopic(tempAiId);
      } else if (status == "success") {
        _this.clearQuickAddParams(fieldObj);
        this.setState({
          topicCount: response.data.length
        }, () => {
          window.history.pushState({ topicCountChange: 1, currentTopicCount: this.state.topicCount - 1 }, '', window.location.href);
        });
        this.refreshLegacyData(response.data);
      }
    })
      .catch((e) => {
        if (e.responseJSON.data) {
          toastr.error(e.responseJSON.data)
        }
      })
      .always(() => {
        window.hideAppLoader('saveMeetingTopic');
      });
    // TODO: add handling block; what if save fails?
  }

  checkSmartWoboTake = (take) => {
    const MIN_SCORE = 0.5
    const AI_TAG = 1;
    const regex = /<u>|<a|<li>|<em>|<strong>/;

    return +take?.smart_suggest_score > MIN_SCORE && take?.tag !== AI_TAG && !regex.test(take?.description)
  };

  generateSecureRandomId = () => {
    var buf = new Uint32Array(1);
    window.crypto.getRandomValues(buf);
    return buf[0];
  }

  addOptimisticTopicTake = (request) => {
    const { actions, meetingData } = this.props;
    const { meeting_topics } = meetingData;
    const topicBase = { ...meeting_topics[0] };
    let topic = {
      ...topicBase,
      id: request.pos,
      description: "",
      aiOwnerName: `${request?.firstName} ${request?.lastName}`,
      tag: 0,
      pos: request.pos,
      wobo_type: "topic",
      create_period: this.currentDateTime(),
      access: 1,
      canEdit: true,
      canDelete: true,
      added_by: this.props.meetingData.currentUser.id,
      topic_take: []
    };

    if (request.descTopic) {
      topic.description = request.descTopic;
    }
    if (request.descTakeaway) {
      topic.topic_take.push({
        added_by: this.props.meetingData.currentUser.id,
        aiOwnerName: `${request?.firstName} ${request?.lastName}`,
        ai_id: null,
        canDelete: true,
        canEdit: true,
        create_at: this.currentDateTime(),
        create_period: this.currentDateTime(),
        created_date: this.currentDateTime(),
        description: request.descTakeaway,
        files: [],
        firstname: request.firstName,
        id: request.pos,
        is_encrypted: null,
        lastname: request.lastName,
        meeting_id: this.props.meetingData.meeting.id,
        pos: request.pos,
        smart_suggest_score: "0",
        smart_suggest_utilized: "0",
        state: null,
        tag: request.tagTake,
        takeaway_to_discuss: false,
        teamId: null,
        topic_id: request.pos,
        user_picture: "",
        wobo_type: "take"
      });
    }

    if(request.descTopic || request.descTakeaway) {
      actions.MeetingUpdateTopics([{...topic}, ...meeting_topics]);
      return [{...topic}, ...meeting_topics];
    };

    return [];
  }; 

  removeOptimisticTopicTake = (optMeetingTopics, request) => {
    const { actions } = this.props;
    if(optMeetingTopics.length) {
      const rollbackMeetingTopics = optMeetingTopics.filter(topic => topic.id !== request.pos);
      actions.MeetingUpdateTopics([...rollbackMeetingTopics]);
    }
  };

  async saveInitMeetingTopicTakeaway(request) {
    const { actions, meetingData } = this.props;
    const { meeting_topics } = meetingData;

    const randNum = this.generateSecureRandomId();
    const currentTopicsId = meeting_topics.map(m => m.id);

    window.showAppLoader('saveMeetingTopic');
    const optMeetingTopics = this.addOptimisticTopicTake(request);
    try {
      const topicFieldObj = $(`#meeting_topic_${request.meetingId}`);
      const takeFieldObj = $(`#meeting_take_${request.meetingId}`);
      let newTopicId = '';
      let topicResponse = null;
      let takeResponse = null;

      // Verify Topic has data to call API
      if (request.descTopic) {
        const topicFieldData = {
          YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
          description: request.descTopic,
          meeting_id: request.meetingId,
          tag: request.tagTopic,
          pos: request.pos,
          ...(request.topicQuickAddAI ? { ...request.topicQuickAddAIParams } : {})
        };
        const topicUrl = `${wbConfig.baseUrl}/restapi/meetings/${request.meetingId}/topics`;
        try {
          topicResponse = await Promise.resolve($.post(topicUrl, topicFieldData));
          newTopicId = topicResponse.data.filter(topic => !currentTopicsId.includes(topic.id))?.[0]?.id || null;
          $(topicFieldObj).prop("disabled", true);
        } catch (error) {
          this.removeOptimisticTopicTake(optMeetingTopics, request);
          actions.MeetingDelteTopic(randNum);
          if (error.responseJSON && error.responseJSON.data) {
            toastr.error(error.responseJSON.data)
          }
        }
      }
      // Verify Take has data to call API
      if (request.descTakeaway) {
        const topicId = newTopicId || 0;
        const takeFieldData = {
          YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
          meeting_id: request.meetingId,
          description: request.descTakeaway,
          tag: request.tagTake,
          pos: request.pos,
          topicId,
          fromTopicAdd: false,
          smart_suggest_utilized: 0,
          ...(request.takeQuickAddAI ? { ...request.takeQuickAddAIParams } : {})
        };
        const takeUrl = `${wbConfig.baseUrl}/restapi/meetings/${request.meetingId}/topics/${topicId}/takeaways`;

        try {
          takeResponse = await Promise.resolve($.post(takeUrl, takeFieldData));
          $(takeFieldObj).prop("disabled", true);
        } catch (error) {
          this.removeOptimisticTopicTake(optMeetingTopics,request);
          console.log(`newMeeting > saveInitMeetingTopicTakeaway: Take POST `, response.error);
          window.history.pushState({ createAIError: response.error }, '', window.location.href);
        }
      }

      // Perform Component updates
      if (newTopicId || takeResponse?.data?.length) {
        this.clearQuickAddParams(topicFieldObj);
        this.clearQuickAddParams(takeFieldObj);
        // TODO: Seems the same prop is updated from two different payloads, need to choose a primary
        const responseTopicCount = takeResponse?.data?.length || topicResponse?.data?.length || 1;
        this.setState({
          topicCount: responseTopicCount,
        }, () => {
          window.history.pushState(
            {
              topicCountChange: 1,
              currentTopicCount: this.state.topicCount - 1
            }, '', window.location.href);
        });

        if (takeResponse?.data?.length) {
          const newTake = takeResponse.data.filter(topic => !currentTopicsId.includes(topic.id))?.[0]?.topic_take?.[0] || null;
          this.removeOptimisticTopicTake(optMeetingTopics, request);
          actions.MeetingUpdateTopics(takeResponse.data);
          this.refreshLegacyData(takeResponse.data, true);

          if (newTake && this.checkSmartWoboTake(newTake)) {
            actions.MeetingSetTakeSmartWoboId(newTake.id)
          }
          const take = this.findTakeInTopics(takeResponse.data, '', request.pos, request.descTakeaway);
          if (take) {
            create_topic("meet", {
              action: "add",
              data: take,
              type: "take"
            });
          }

          if (typeof request.takeCB === "function") {
            const takeId = take ? take.id : '';
            request.takeCB.call(takeId, request.descTakeaway);
          }
        } else if (topicResponse?.data?.length) {
          // TODO: This is need because refreshLegacyData is expecting just one payload, 
          // and in the scenario where a topic and a takeaway are creating together
          // takeaway data comes after with the most updated payload.
          this.removeOptimisticTopicTake(optMeetingTopics, request);
          this.refreshLegacyData(topicResponse.data);
        }
      }
    } catch (error) {
      console.error(`newMeeting > saveInitMeetingTopicTakeaway: request payload: ${JSON.stringify(request)} `, error)
    } finally {
      window.hideAppLoader('saveMeetingTopic');
    }
  }

  clearQuickAddParams(obj) {
    $(obj).data("teamId", "");
    $(obj).data("quickAddTagId", "");
    $(obj).data("quickAddUserId", "");
    $(obj).data("quickAddAI", "");
    $(obj).val("");
  }

  updateTopicTake(
    desc,
    meetingId,
    topicId,
    tagId,
    fname,
    lname,
    TypeStr,
    takeId = null,
    quickAddAI = false,
    quickAddAIParams = {},
    callback = null,
    updateFromEmpty = false,
    topicToTake = false
  ) {
    const _this = this;
    const { actions } = this.props;
    let takeSmartWoboId = null;

    let fieldData = {
      YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
      meeting_id: meetingId,
      description: desc,
      tag: tagId,
      id: topicId,
      type: TypeStr
    };

    if (quickAddAI == true) {
      fieldData.tag = 1; // required to distinguish an AI, removes a smartbullet
      fieldData = Object.assign({}, fieldData, quickAddAIParams);
    }

    let url = "";
    let fieldObj = "";
    if (TypeStr == "topic") {
      url = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics${topicId != "" ? `/${topicId}` : ""}`
      fieldObj = $(
        `#meeting_topic_${meetingId}${topicId != "" ? `_${topicId}` : ""}`
      );
    } else if (TypeStr == "nonTake") {
      url = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/${topicId}/takeaways/${takeId}`
      fieldObj = $(
        `#meeting_take_${meetingId}${topicId != "" ? `_${topicId}` : ""}`
      );
    } else {
      url = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/${topicId}/takeaways/${takeId}`
      fieldObj = $(
        `#meeting_take_${meetingId}${topicId != "" ? `_${topicId}` : ""}`
      );
    }

    if (TypeStr == "topic" && topicToTake == true) {
      $(fieldObj).val(desc).html(desc)
    }
    $.ajax({
      method: 'PATCH', url, data: fieldData, success: (data, status) => {
        removeLoaderWidget();
        $(fieldObj).prop("disabled", true);
        if (data.error) {
          $(fieldObj).val(desc);
          alert(data.error);
          window.location.reload();
          return false;
        } else if (status == "success") {
          _this.clearQuickAddParams(fieldObj);

          // Verify smartWobo score update
          if (TypeStr === 'take') {
            const updateTake = data.data.find(topic => topic.id === topicId)?.topic_take?.find(take => take.id === takeId);

            if (updateTake && this.checkSmartWoboTake(updateTake)) {
              takeSmartWoboId = updateTake.id;
              actions.MeetingSetTakeSmartWoboId(takeSmartWoboId)
            }
          }
          if (updateFromEmpty) {
            create_topic("meet", {
              action: "add",
              data: _this.state.topicEmptyData,
              type: "topic"
            });
            actions.MeetingAddTopicItems(_this.state.topicEmptyData);
            _this.setState({ takeTopicId: "" });
          }
          if (data.data) {
            if (TypeStr == "topic") {
              if (topicToTake == true) {
                $(fieldObj).val(desc).html(desc)
                _this.setState({
                  takeTopicId: data.data.id,
                  emptyGlobalTag: tagId,
                  topicEmptyData: data.data
                });
                if ($(`#cke_meeting_take_${meetingId}`).length == 0) {
                  $(`#meeting_take_${meetingId}`).trigger("click");
                }
              }
            }

            this.refreshLegacyData(data.data, false, takeSmartWoboId);

            create_topic("meet", {
              action: "update",
              type: TypeStr,
              data: data.data,
              topicId: takeId
            });

          }
          if (typeof callback === "function") {
            callback.apply(null, [desc, topicId]);
          }
        }
      }
    });
  }

  currentDateTime() {
    // TODO: move to /utils or use an existing utility method
    const m = moment.utc();
    let timestamp = m.format("X");
    const { currentUser } = this.props.meetingData;
    let offset = 0;
    if (typeof currentUser.offset !== "undefined") {
      offset = currentUser.offset;
      if (offset != null && offset != "") {
        timestamp = parseInt(timestamp) + offset;
      }
    }
    return moment.utc(timestamp * 1000).format("hh:mm a MMM DD");
  }

  saveMeetingTakeAway(
    desc,
    meetingId,
    tag,
    pos,
    fname,
    lname,
    topicRelId,
    quickAddAI = false,
    quickAddAIParams = {},
    callback = null,
    fromTopicAdd = false,
    smart_suggest_utilized = 0
  ) {
    const { actions, meetingData } = this.props;
    const { meeting_topics } = meetingData;
    let fieldData = {
      YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN,
      meeting_id: meetingId,
      description: desc,
      tag,
      pos,
      topicId: topicRelId,
      fromTopicAdd,
      smart_suggest_utilized
    };
    if (quickAddAI == true) {
      fieldData.tag = 1; // required to distinguish an AI, removes a smartbullet
      fieldData = Object.assign({}, fieldData, quickAddAIParams);
    }
    const fieldId = `meeting_take_${meetingId}${topicRelId != "" ? `_${topicRelId}` : ""
      }`;
    const fieldObj = $(`#${fieldId}`);
    const _this = this;
    const addAiUrl = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/${topicRelId}/takeaways`
    window.showAppLoader('saveMeetingTakeAway');
    const posting = $.post(addAiUrl, fieldData, (response, status) => {
      $(fieldObj).prop("disabled", true);
      if (response.error) {
        $(fieldObj).val(desc);
        window.history.pushState({ createAIError: response.error }, '', window.location.href);
      } else if (status == "success") {
        _this.clearQuickAddParams(fieldObj);
        this.setState({
          topicCount: response.data.length
        }, () => {
          window.history.pushState({ topicCountChange: 1, currentTopicCount: this.state.topicCount - 1 }, '', window.location.href);
        });
        const currentTopicTakesId = meeting_topics.filter(m => m.id === topicRelId)?.[0]?.topic_take?.map(t => t.id);
        const newTake = response.data?.filter(m => m.id === topicRelId)?.[0]?.topic_take?.filter(t => !currentTopicTakesId.includes(t.id))?.[0] || null;
        actions.MeetingUpdateTopics(response.data);
        this.refreshLegacyData(response.data, true);
        if (newTake && this.checkSmartWoboTake(newTake)) {
          actions.MeetingSetTakeSmartWoboId(newTake.id)
        }

        const take = this.findTakeInTopics(response.data, topicRelId, pos, desc);
        if (take) {
          create_topic("meet", {
            action: "add",
            data: take,
            type: "take",
            topicId: topicRelId
          });
        }

        if (typeof callback === "function") {
          const takeId = take ? take.id : '';
          callback.call(takeId, desc);
        }
      }
    }
    ).always(() => {
      window.hideAppLoader('saveMeetingTakeAway');
    });

    this.setState({
      emptyGlobalTag: 0
    });
  }

  deleteTopicTakeNonTake(idToDelete, meetingId, type, topicId = null, isFUSEnabled = null, files = []) {
    let url = "";
    let data = "";
    if (type == "topic") {
      url = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/${idToDelete}`
    } else if (type == "nonTake") {
      // TODO - revisit when nullTopicWithTake is implement on BE
      // url = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/${topicId}/takeaways/${idToDelete}`
      url = wbConfig.baseUrl + '/meeting/deleteMeetingTake';
      data = { id: idToDelete };
    } else if (type == "take") {
      url = `${wbConfig.baseUrl}/restapi/meetings/${meetingId}/topics/${topicId}/takeaways/${idToDelete}`
    }
    if (isFUSEnabled ) {
      if (Array.isArray(files) && files.length > 0) {
        files.forEach(function(file){
          WoboFileUploadService.delete(file.fileSignature)
        })
      } else {
        if(files.fileSignature) {
          WoboFileUploadService.delete(files.fileSignature)
        }
      }
    }
    
    if (url) {
      window.showAppLoader('deleteTopicTake');
      $.ajax({
        method: 'DELETE', url, success: (data, status) => {
          if (data.error) {
            window.history.pushState({ showError: data.error }, '', window.location.href);
          } else if (status == "success") {
            if (type === 'topic') {
              this.setState({
                topicCount: this.state.topicCount - 1,
              }, () => {
                window.history.pushState({ topicCountChange: -1, currentTopicCount: this.state.topicCount + 1 }, '', window.location.href);
              });
            }

            this.refreshLegacyData(data.data);

            create_topic("meet", {
              action: "delete",
              type,
              data: { id: idToDelete },
              topicId
            });
          }
        }
      })
        .always(() => {
          window.hideAppLoader('deleteTopicTake');
        });
    }
  }

  enablegroupText() {
    const _this = this;
    _this.setState({
      enableDesc: !this.state.enableDesc
    });
  }

  addDesc(content, id) {
    const { actions } = this.props;

    const objective = content;
    if (objective == "") {
      $(".noObjectiveDes").show();
    }
    $(".pencilImg").show();
    const eleIdB = "objective";
    const instance = CKEDITOR.instances[eleIdB];
    if (instance) {
      CKEDITOR.instances[eleIdB].destroy();
    }
    actions.MeetingUpdateObject(id, { objective });
    this.forceUpdate();

    // TODO: better fail-state/error handling below
    $.ajax({
      url: `${wbConfig.baseUrl}/meeting/updateMeetingObj`,
      type: "post",
      data: { id, objective }
    })
      .done(response => {
        if (response.error) {
          //console.log(response.error);
        }
      })
      .fail(response => {
        //console.log("Please try again later", response);
      });
  }

  showAddAttendeePopupClick() {
    this.setState(prevState => ({
      showAddAttendeePopup: !prevState.showAddAttendeePopup
    }));
  }

  showAttendeeOptsDiv(attendeeOptIdVal) {
    const selectedUser = this.props.meetingData;
    const showAttendeeOpts = !!(
      selectedUser.userPermission.meetingAccess &&
      selectedUser.meeting.status == 1
    );
    this.setState({
      showAttendeeOpts,
      attendeeOptId: attendeeOptIdVal
    });
  }

  hideAttendeeOptsDiv() {
    this.setState({
      showAttendeeOpts: false,
      attendeeOptId: null
    });
  }

  keypress() {
    const rows1 = $(".planMeetingTextarea").val();
    if (rows1) {
      const rows = rows1.split("\n");
      this.setState({
        descHeight: rows + 1
      });
    }
  }

  sortItemNotes(id, list) {
    const { actions } = this.props;
    actions.MeetingUpdateSortData(id, { item: list });
  }

  sortTakeNotes(id, list) {
    const { actions } = this.props;
    actions.MeetingTakeUpdateSortData(id, { item: list });
  }

  addTopicAttach(topicId, list) {
    const { actions } = this.props;
    actions.MeetingTopicAttachAdd(topicId, { item: list });
  }

  addNoteAttach(topicid, takeid, list) {
    const { actions } = this.props;
    actions.MeetingNoteAttachAdd(topicid, takeid, { item: list });
  }

  deleteTopicAttach(topicId, id) {
    const { actions } = this.props;
    actions.MeetingTopicAttachDelete(topicId, { id });
  }

  deleteNoteAttach(topicid, takeid, id) {
    const { actions } = this.props;
    actions.MeetingNoteAttachDelete(topicid, takeid, { id });
  }

  clearGlobalValue() {
    this.setState({
      disabledDoneBtn: 1
    });
  }

  clearGlobalValueBta() {
    if (this.state.resetTopicTag == 0) {
      this.setState({
        disabledDoneBtn: 0,
        emptyGlobalTag: 0,
        resetTopicTag: 3
      });
    } else {
      this.setState({
        disabledDoneBtn: 0,
        emptyGlobalTag: 0,
        resetTopicTag: 0
      });
    }
  }

  updateTopicAttach(topicId, list) {
    const { actions } = this.props;
    actions.MeetingTopicAttachUpdate(topicId, { item: list });
  }

  updateNoteAttach(topicid, takeid, list) {
    const { actions } = this.props;
    actions.MeetingNoteAttachUpdate(topicid, takeid, { item: list });
  }

  render() {
    const selectedUser = this.props.meetingData;
    const meetingId = selectedUser.meeting.id;

    return (
      <div
        key={`meeting_details_${meetingId}`}
        className="mainDiv meetingDetailsMainDiv"
        ref={elem => this.meetingAppRef = elem}
        id={'meeting_details_div'}
        style={{ paddingTop: 8, boxSizing: 'content-box' }}
      >
        <MainDetailsMeetingWrapper
          actions={this.props.actions}
          {...this.props.meetingData}
          saveMeetingTopic={this.saveMeetingTopic}
          saveTags={this.saveTags}
          saveMeetingTakeAway={this.saveMeetingTakeAway}
          editTopicArea={this.editTopicArea}
          showTopicDescEdit={this.props.showTopicDescEdit}
          deleteTopicTakeNonTake={this.deleteTopicTakeNonTake}
          updateTopicTake={this.updateTopicTake}
          shareMeetingTopic={this.shareMeetingTopic}
          mentionsUserData={this.state.mentionsUserData}
          sortItemNotes={this.sortItemNotes}
          saveMeetingNullTopicNote={this.saveMeetingNullTopicNote}
          sortTakeNotes={this.sortTakeNotes}
          deleteTopicAttach={this.deleteTopicAttach}
          deleteNoteAttach={this.deleteNoteAttach}
          addTopicAttach={this.addTopicAttach}
          addNoteAttach={this.addNoteAttach}
          clearGlobalValue={this.clearGlobalValue}
          tempVar={this.state.tempVar}
          takeTopicId={this.state.takeTopicId}
          emptyGlobalTag={this.state.emptyGlobalTag}
          disabledDoneBtn={this.state.disabledDoneBtn}
          clearGlobalValueBta={this.clearGlobalValueBta}
          resetTopicTag={this.state.resetTopicTag}
          saveTakeawayAsAi={this.saveTakeawayAsAi}
          resetMeetingTakesForSmartWobo={this.resetMeetingTakesForSmartWobo}
          refreshLegacyData={this.refreshLegacyData}
          saveInitMeetingTopicTakeaway={this.saveInitMeetingTopicTakeaway}
          updateTopicAttach={this.updateTopicAttach}
          updateNoteAttach={this.updateNoteAttach}
        />
        <div className="clear" />
      </div>
    );
  }
}


export default NewMeetingApp
